import React, { useState, useEffect, useRef } from 'react';
import {
  Col,
  Nav,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Container,
  FlexboxGrid,
  useToaster,
  Message
} from 'rsuite';
import globalIP from '../../GlobelIP';
import LoadingBar from 'react-top-loading-bar';
import MenuIcon from '@rsuite/icons/Menu';
import { Link } from 'react-router-dom';
import ugr from '@/UGRoute';
import axios from 'axios';
import ProcessMaster from './MastersComponent/ProcessMaster';
import CollectionMaster from './MastersComponent/CollectionMaster';
import FinishMaster from './MastersComponent/FinishMaster';
import ColorMaster from './MastersComponent/ColorMaster';
import HSNCodeMaster from './MastersComponent/HSNCodeMaster';
import MaterialNameMaster from './MastersComponent/MaterialNameMaster';
import ShapeMaster from './MastersComponent/ShapeMaster';
import SeasonMaster from './MastersComponent/SeasonMaster';
import PTechNameMaster from './MastersComponent/PTechNameMaster';
import CostingHeadMaster from './MastersComponent/CostingHeadMaster';
import CurrencyMaster from './MastersComponent/CurrencyMaster';
import CompNameMaster from './MastersComponent/CompNameMaster';
import Footer from '@/components/Footer/Footer';
import useTableHeight from '@/components/useTableHeight';
import ProductTypeMaster from './MastersComponent/ProductTypeMaster';
import CategoryMaster from './MastersComponent/CategoryMaster';
interface RowDatacategorydata {
  id: string; // or number, depending on your data
  attributes: {
    CategoryCode: string;
    CategoryName: string;
    ShortName: string;
  };
}
interface RowDataProducttype {
  id: string; // or number, depending on your data
  attributes: {
    ProductTypeCode: string;
    ProductTypeName: string;
    CategoryCode: string;
    Categorycode: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const Master = () => {
  const ip = globalIP;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const [openSet, setOpenSet] = useState(false);
  const [activeKey, setActiveKey] = useState('content1');
  const handleNavSelect = eventKey => {
    setActiveKey(eventKey);
  };
  //-------Label Api data fetch
  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${ip}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  //-------category Api data fetch
  const toaster = useToaster();
  const [editedRowIds, setEditedRowIds] = useState<string[]>([]);
  const [editedRowId, setEditedRowId] = useState<string>('');
  const [editedData, setEditedData] = useState<
    Record<string, Partial<RowDatacategorydata['attributes']>>
  >({});

  const [category, setCategory] = useState({
    CategoryCode: '',
    CategoryName: '',
    ShortName: '',
    dis: 'Continue'
  });
  //---------Fetch Data from API Start
  const [categorydata, setCategorydata] = useState<RowDatacategorydata[]>([]);
  const [categorymeta, setCategorymeta] = useState<MetaData>();
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [page, setPage] = useState(1);
  const [page1, setPage1] = useState(1);
  const [selectedBuyer, setSelectedBuyer] = useState('Continue');
  const [discate, setDiscate] = useState([]);
  const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

  const handleBuyerChange = value => {
    setSelectedBuyer(value);
  };
  useEffect(() => {
    fetchData();
  }, [selectedBuyer, page]);
  const fetchData = async () => {
    setProgress(30);
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    setProgress(60);
    let disFilter = '';
    if (selectedBuyer.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyer}`;
    }
    if (selectedBuyer == 'All') {
      disFilter = '';
    }
    const response = await fetch(
      `${ip}/api/mstcategories?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mstcategories?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${ip}/api/mstcategories?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();

    const response2 = await fetch(`${ip}/api/mstcategories`);
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mstcategories?populate=*&pagination[page]=${page}&sort[0]=id`
      );
      const pageJson = await pageResponse.json();
      const processedData = pageJson.data.map(item => ({
        label: item.attributes.CategoryName,
        value: item.attributes.CategoryCode
      }));
      allData2.push(...processedData);
    }
    setDiscate(allData2);
    setCategorymeta(jsonmeta.meta);
    setCategorydata(allData);
    setIsLoading(false);
    setProgress(100);
  };
  const handleEditRowCategory = rowData => {
    setCategory({ ...rowData.attributes });
    setEditedRowId(rowData.id);
    setEditedRowIds(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedData(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };
  const resetCategory = () => {
    setCategory({
      CategoryCode: '',
      CategoryName: '',
      ShortName: '',
      dis: 'Continue'
    });
  };
  const handleCancelCategory = rowData => {
    resetCategory();
    setEditedRowId('');
    setEditedRowIds('');
  };
  const url = `${ip}/api/mstcategories`;
  const submit = async e => {
    e.preventDefault();

    const trimmedCategoryName = category.CategoryName?.trim();
    const trimmedCategoryShort = category.ShortName?.trim();
    // const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;
    // Validate inputs
    if (trimmedCategoryName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.Category}.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }
    if (trimmedCategoryShort === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter Short Name.
        </Message>,
        { placement: 'topCenter' }
      );
      return;
    }
    // if (specialCharPattern.test(trimmedCategoryName)) {
    //   toaster.push(
    //     <Message showIcon type="error">
    //       {label[0]?.attributes.Category} should not contain special characters.
    //     </Message>,
    //     { placement: 'topCenter' }
    //   );
    //   return;
    // }
    try {
      const { data: catefilterData } = await axios.get(
        `${ip}/api/mstcategories?filters[CategoryName][$eqi]=${trimmedCategoryName}`
      );
      const { data: catefilterDatacode } = await axios.get(
        `${globalIP}/api/mstcategories?populate=*`
      );
      const nextCode = catefilterDatacode.meta.pagination.total + 1;
      // Filter valid entries
      const validDiscate = discate.filter(item => item?.attributes?.CategoryName);
      const validCategorydata = categorydata.filter(item => item?.attributes?.ShortName);
      // Check for existing category or short name
      const existingCategory = validDiscate.find(
        item => item.attributes.CategoryName.toLowerCase() === trimmedCategoryName.toLowerCase()
      );
      const existingCategoryShort = validCategorydata.find(
        item => item.attributes.ShortName.toLowerCase() === trimmedCategoryShort.toLowerCase()
      );

      if (catefilterData.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Category} {trimmedCategoryName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      if (existingCategoryShort) {
        toaster.push(
          <Message showIcon type="warning">
            Short Name {trimmedCategoryShort} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      // Prepare form data
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ...category,
          CategoryName: trimmedCategoryName,
          CategoryCode: `CAT-${nextCode.toString().padStart(3, '0')}`,
          ShortName: trimmedCategoryShort
        })
      );
      // Make POST request
      const response = await fetch(url, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        await fetchData(); // Refresh data
        toaster.push(
          <Message showIcon type="success">
            Data Saved Successfully.
          </Message>,
          { placement: 'topCenter' }
        );
        // Reset the category form
        setCategory({
          CategoryCode: '',
          CategoryName: '',
          ShortName: '',
          dis: 'Continue'
        });
      } else {
        console.error('Failed to save data');
        toaster.push(
          <Message showIcon type="error">
            Failed to save data. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred:', error);
      toaster.push(
        <Message showIcon type="error">
          An error occurred. Please try again later.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };
  //  Fetch Data from API End
  const handleInputChange = (inputName, value, index) => {
    setCategory({ ...category, [inputName]: value });
  };
  // Status Start
  const fetchCategoryData = async catalogId => {
    const categoryResponse = await fetch(`${ip}/api/mstcategories/${catalogId}`);
    const categoryData = await categoryResponse.json();
    console.log('categoryData--->', categoryData);
    // const categoryData = categorydata.filter(item => item.id === catalogId);
    const response = await fetch(
      `${ip}/api/mstproducttypes/?populate=*&filters[Categorycode][$eq]=${categoryData.data.attributes.CategoryCode}&filters[dis][$eq]=Continue`
    );
    const data = await response.json();
    return data;
  };
  // Status Start
  const handleStatusDCat = async catalogId => {
    try {
      const categoryData = await fetchCategoryData(catalogId);

      const categoryPromises = categoryData.data.map(
        item =>
          new Promise(async (resolve, reject) => {
            const data = await handleStatusDptye(item.id);
            if (data) {
              resolve(data);
            } else {
              reject(data);
            }
          })
      );
      await Promise.allSettled(categoryPromises);
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ...categorydata,
          dis: 'Discontinue'
        })
      );
      fetch(`${ip}/api/mstcategories/${catalogId}`, {
        method: 'PUT',
        body: formData
      })
        .then(response => response.json())
        .then(data => {
          // console.log(data);
          fetchData();
          // Refresh page after 2 seconds (2000 milliseconds)
        })
        .catch(error => {
          console.error(error);
        });
    } catch (e) {
      console.log(e);
    }
  };
  // const handleStatusDCatt = async catalogId => {
  //   const formData = new FormData();
  //   formData.append(
  //     'data',
  //     JSON.stringify({
  //       ...categorydata,
  //       dis: 'Discontinue'
  //     })
  //   );
  //   fetch(`${ip}/api/mstcategories/${catalogId}`, {
  //     method: 'PUT',
  //     body: formData
  //   })
  //     .then(response => response.json())
  //     .then(data => {
  //       console.log(data);
  //       fetchData();
  //       // Refresh page after 2 seconds (2000 milliseconds)
  //     })
  //     .catch(error => {
  //       console.error(error);
  //     });
  // };

  const handleStatusCCat = async catalogId => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...categorydata,
        dis: 'Continue'
      })
    );
    fetch(`${ip}/api/mstcategories/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData();
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleSaveRowCategory = async (rowId: string) => {
    try {
      // const rowData = categorydata.find(row => row.id === rowId);
      if (!category) {
        console.error('Row data not found.');
        return;
      }
      // Trim `CategoryName` and check for special characters
      const updatedCategoryName = category?.CategoryName?.trim() || '';
      const updatedCategoryShort = category?.ShortName?.trim() || '';
      // const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

      if (!updatedCategoryName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter {label[0]?.attributes.Category}.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      if (!updatedCategoryShort) {
        toaster.push(
          <Message showIcon type="error">
            Please enter Short Name.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }

      // if (specialCharPattern.test(updatedCategoryName)) {
      //   toaster.push(
      //     <Message showIcon type="error">
      //       {label[0]?.attributes.Category} should not contain special characters.
      //     </Message>,
      //     { placement: 'topCenter' }
      //   );
      //   return;
      // }

      const { data: updatecatefilterData } = await axios.get(
        `${ip}/api/mstcategories?filters[$or][0][CategoryName][$eqi]=${updatedCategoryName}&filters[id][$ne]=${editedRowId}`
      );
      if (updatecatefilterData.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Category} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      // const updatedRowData = {
      //   ...rowData,
      //   attributes: {
      //     ...rowData.attributes,
      //     ...editedData[rowId],
      //     CategoryName: updatedCategoryName // Use trimmed name for saving
      //   }
      // };
      const response = await fetch(`${ip}/api/mstcategories/${editedRowId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { ...category, CategoryName: updatedCategoryName } })
      });

      if (response.ok) {
        await fetchData();
        resetCategory('');
        setEditedRowId('');
        setEditedData(prevData => ({
          ...prevData,
          [editedRowId]: { ...category, CategoryName: updatedCategoryName } // Ensure UI updates correctly
        }));
        setEditedRowIds(prevRowIds => [...new Set([...prevRowIds, editedRowId])]);
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };

  const handleInputChangeCategory = (rowId, fieldName, value) => {
    setEditedData(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...categorydata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  ////////////////  Function For 1 End /////////////////
  ////////////////  Function For 2 Start /////////////////
  const [selectedCategoryCode, setSelectedCategoryCode] = useState('');
  const [productType, setProductType] = useState({
    ProductTypeCode: '',
    ProductTypeName: '',
    Categorycode: '',
    dis: 'Continue'
  });

  // Fetch Data from API Start
  const [productTypedata, setProductTypedata] = useState<RowDataProducttype[]>([]);
  const [productTypemeta, setProductTypemeta] = useState<MetaData>();
  const [isLoading2, setIsLoading2] = useState(false);
  const [editedRowIdsProduct, setEditedRowIdsProduct] = useState<string[]>([]);
  const [editedRowIdProduct, setEditedRowIdProduct] = useState<string>('');
  const [editedDataProduct, setEditedDataProduct] = useState<
    Record<string, Partial<RowDataProducttype['attributes']>>
  >({});
  const [selectedBuyerp, setSelectedBuyerp] = useState('Continue');
  const [disProt, setDisProt] = useState([]);
  const [catedata, setCatedata] = useState([]);
  const handleBuyerChangep = value => {
    setSelectedBuyerp(value);
  };
  useEffect(() => {
    fetchData2();
  }, [selectedBuyerp, page1]);
  const fetchData2 = async () => {
    setIsLoading2(true);
    let disFilter = '';
    if (selectedBuyerp.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyerp}`;
    }
    if (selectedBuyerp == 'All') {
      disFilter = '';
    }
    const response = await fetch(
      `${ip}/api/mstproducttypes?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const json = await response.json();
    const allData = [];
    for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mstproducttypes?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${ip}/api/mstproducttypes?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();
    const response2 = await fetch(`${ip}/api/mstproducttypes`);
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mstproducttypes?populate=*&pagination[page]=${page}`
      );
      const pageJson2 = await pageResponse.json();
      allData2.push(...pageJson2.data);
    }

    const response3 = await fetch(`${ip}/api/mstcategories`);
    const allData3 = [];
    const pageJson3 = await response3.json();
    for (let page = 1; page <= pageJson3.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${ip}/api/mstcategories?populate=*&pagination[page]=${page}`
      );
      const pageJson3 = await pageResponse.json();
      allData3.push(...pageJson3.data);
    }
    setCatedata(allData3);
    setDisProt(allData2);
    setProductTypedata(allData);
    setProductTypemeta(jsonmeta.meta);
    setIsLoading2(false);
  };

  useEffect(() => {
    console.log('selectedCategoryCode');
    console.log(selectedCategoryCode);
  }, [selectedCategoryCode]);
  const processInputRef = useRef(null);
  const handleEditRowProduct = rowData => {
    setProductType({ ...rowData.attributes });
    setSelectedCategoryCode(rowData.attributes.Categorycode);
    setEditedRowIdProduct(rowData.id);
    setEditedRowIdsProduct(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataProduct(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };
  const resetProduct = () => {
    setProductType({
      ProductTypeCode: '',
      ProductTypeName: '',
      Categorycode: '',
      dis: 'Continue'
    });
  };
  const handleCancelPtech = () => {
    resetProduct();
    setEditedRowIdProduct('');
    setSelectedCategoryCode('');
    setEditedRowIdsProduct([]); // Empty array instead of empty string
  };
  const url2 = `${ip}/api/mstproducttypes`;
  const submit2 = async e => {
    if (selectedCategoryCode) {
      e.preventDefault();
      const trimmedProductTypeName = productType.ProductTypeName?.trim();
      // const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;
      if (trimmedProductTypeName === '') {
        toaster.push(
          <Message showIcon type="error">
            Please Enter {label[0]?.attributes.ProductType}.
          </Message>,
          { placement: 'topCenter' }
        );
      } 
      // else if (specialCharPattern.test(trimmedProductTypeName)) {
      //   toaster.push(
      //     <Message showIcon type="error">
      //       {label[0]?.attributes.ProductType} should not contain special characters.
      //     </Message>,
      //     { placement: 'topCenter' }
      //   );
      // } 
      else if (
        productType.ProductTypeName.startsWith(' ') ||
        productType.ProductTypeName.endsWith(' ')
      ) {
        toaster.push(
          <Message>{label[0]?.attributes.ProductType} cannot End with a space.</Message>
        );
      } else {
        try {
          // const { data: profilterData } = await axios.get(
          //   `${ip}/api/mstproducttypes?populate=*&filters[ProductTypeName][$eqi]=${trimmedProductTypeName}`
          // );
          const { data: profilterData } = await axios.get(
  `${ip}/api/mstproducttypes?populate=*&filters[ProductTypeName][$eqi]=${encodeURIComponent(trimmedProductTypeName)}&filters[Categorycode][$eq]=${selectedCategoryCode}`
);

          console.log('profilterData ---> ', profilterData);
          const { data: profilterDatacode } = await axios.get(
            `${globalIP}/api/mstproducttypes?populate=*`
          );
          const nextCode = profilterDatacode.meta.pagination.total + 1;
          const existingCategory = disProt.find(
            item =>
              item.attributes.Categorycode?.toLowerCase() === selectedCategoryCode.toLowerCase() &&
              item.attributes.ProductTypeName.toLowerCase() ===
                productType.ProductTypeName.toLowerCase()
          );

          if (profilterData.data.length) {
            toaster.push(
              <Message showIcon type="warning">
                {label[0]?.attributes.ProductType} {productType.ProductTypeName} with same Category
                already exists.
              </Message>,
              { placement: 'topCenter' }
            );
          } else {
            // nextCategoryCode2 = generateNextCategoryCode2();
            // const nextCategoryCode = nextCategoryCode2;
            const formData = new FormData();
            formData.append(
              'data',
              JSON.stringify({
                ...productType,
                ProductTypeCode: `PTY-${nextCode.toString().padStart(3, '0')}`,
                Categorycode: selectedCategoryCode,
                dis: 'Continue' // Add the selected category code
              })
            );
            const response = await fetch(url2, {
              method: 'POST',
              body: formData
            });
            if (response.ok) {
              await fetchData2(); // Wait for data to be fetched before logging
              console.log(productType);

              toaster.push(
                <Message showIcon type="success">
                  Data Save Successfully.
                </Message>,
                { placement: 'topCenter' }
              );
            } else {
              console.error('Failed to save data');
            }
          }
        } catch (error) {
          console.error(error);
        }

        setProductType({
          ProductTypeCode: '',
          ProductTypeName: '',
          Categorycode: '',
          dis: 'Continue'
        });
      }
    } else {
      toaster.push(
        <Message showIcon type="error">
          Please Select {label[0]?.attributes.Category}.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };
  //  Fetch Data from API End
  const handleInputChange2 = (inputName, value) => {
    setProductType({ ...productType, [inputName]: value });
  };

  const handleSaveRowProduct = async rowId => {
    try {
      // const rowData = productTypedata.find(row => row.id === rowId);
      if (!productType) {
        console.error('Row data not found.');
        return;
      }
      console.log('productType?.Categorycode?.trim()', productType?.Categorycode?.trim());
      console.log('productType', productType);

      // Get the updated values for CategoryCode and ProductTypeName
      const updatedCategoryCode = selectedCategoryCode;
      const updatedProductTypeName = productType?.ProductTypeName?.trim() || '';
      // const updatedCategoryCode = editedDataProduct[rowId]?.CategoryCode?.trim();
      // const updatedProductTypeName = editedDataProduct[rowId]?.ProductTypeName?.trim();

      // Check if CategoryCode and ProductTypeName are unique
      const isCategoryCodeUnique = productTypedata.some(
        row =>
          row.id !== rowId &&
          row.Categorycode === updatedCategoryCode &&
          row.ProductTypeName === updatedProductTypeName
      );

      // If CategoryCode or ProductTypeName are not unique, show error message
      if (isCategoryCodeUnique) {
        toaster.push(
          <Message showIcon type="error">
            Dupliacte data
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if CategoryCode is not unique
      }

      // Check if `ProductTypeName` has special characters

      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;
      if (specialCharPattern.test(updatedProductTypeName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.ProductType} cannot contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }

      // Update the row attributes
      // const updatedAttributes = {
      //   ...rowData.attributes,
      //   ...editedDataProduct[rowId],
      //   Categorycode: updatedCategoryCode // Include the edited Categorycode
      // };

      const { data: updateproductN } = await axios.get(
        `${ip}/api/mstproducttypes?filters[ProductTypeName][$eqi]=${updatedProductTypeName}&filters[id][$ne]=${editedRowIdProduct}`
      );
      if (updateproductN.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.ProductType} {updatedProductTypeName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return;
      }
      const existing = productTypedata.find(
        item =>
          // item.id != rowId &&
          item.attributes.ProductTypeName.toLowerCase().trim() ===
            productType.ProductTypeName.toLowerCase().trim() &&
          item.attributes.Categorycode?.toLowerCase().trim() ===
            selectedCategoryCode.toLowerCase().trim()
      );

      if (existing) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.ProductType} {productType.ProductTypeName} with same Category
            already exists.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        // Save the updated data via PUT request
        const response = await fetch(`${ip}/api/mstproducttypes/${editedRowIdProduct}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              ...productType,
              ProductTypeName: updatedProductTypeName,
              Categorycode: selectedCategoryCode // Explicitly set the updated Categorycode
            }
          })
        });

        if (response.ok) {
          await fetchData2(); // Wait for data to be fetched before updating
          resetProduct('');
          setEditedRowIdProduct('');
          setSelectedCategoryCode('');
          setEditedDataProduct(prevData => ({
            ...prevData,
            [editedRowIdProduct]: {
              ...productType,
              ProductTypeName: updatedProductTypeName,
              Categorycode: selectedCategoryCode
            } // Ensure UI updates correctly
          }));
          setEditedRowIdsProduct(prevRowIds => [...new Set([...prevRowIds, editedRowIdProduct])]);
          console.log('Data saved successfully.');
        } else {
          console.error('Failed to save data');
        }
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };
  const handleInputChangeProduct = (rowId, fieldName, value) => {
    setEditedDataProduct(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...productTypedata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  const handleStatusDptye = async productId => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...productTypedata,
        dis: 'Discontinue'
      })
    );
    fetch(`${ip}/api/mstproducttypes/${productId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        // console.log(data);
        fetchData2();
        // Refresh page after 2 seconds (2000 milliseconds)
        return data;
      })
      .catch(error => {
        console.error(error);
      });

    return null;
  };
  const handleStatusCptye = async catalogId => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...productTypedata,
        dis: 'Continue'
      })
    );
    fetch(`${ip}/api/mstproducttypes/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData2();
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  ////////////////  Function For 2 End /////////////////
  ////////////////  Searching For 1 Start /////////////////
  const [searchQuery1, setSearchQuery1] = useState('');
  const [filterDataCata, setFilterDataCata] = useState([]);
  const [filterStatus, setFilteredStatus] = useState('Continue');
  const handleSearch1 = value => {
    setSearchQuery1(value);
  };
  useEffect(() => {
    const filterDataCata = categorydata
      .slice() // Create a shallow copy of the array to avoid modifying the original array
      .reverse()
      .filter(item => {
        const CategoryName = item.attributes.CategoryName
          ? item.attributes.CategoryName.toLowerCase()
          : '';
        return CategoryName.includes(searchQuery1.toLowerCase());
      });
    setFilterDataCata(filterDataCata);
  }, [categorydata, filterStatus, searchQuery1]);

  ////////////////  Searching For 1 End /////////////////
  ////////////////  Searching For 2 Start /////////////////
  const [filterStatus2, setFilteredStatus2] = useState('Continue');
  const [searchQuery2, setSearchQuery2] = useState('');
  const handleSearch2 = value => {
    setSearchQuery2(value);
  };
  const [filterDataOfPrdt, setFilterDataOfPrdt] = useState([]);
  useEffect(() => {
    const filterDataOfPrdt = productTypedata
      .slice() // Create a shallow copy of the array to avoid modifying the original array
      .reverse()
      .filter(item => {
        const ProductTypeName = item.attributes.ProductTypeName
          ? item.attributes.ProductTypeName.toLowerCase()
          : '';
        const Categoryfind = item.attributes.Categorycode;
        const matchingCategory = categorydata.find(
          category => category.attributes.CategoryCode === Categoryfind
        );
        const CategoryName = matchingCategory
          ? matchingCategory.attributes.CategoryName.toLowerCase()
          : '';
        return (
          ProductTypeName.includes(searchQuery2.toLowerCase()) ||
          CategoryName.includes(searchQuery2.toLowerCase())
        );
      });
    setFilterDataOfPrdt(filterDataOfPrdt);
  }, [productTypedata, filterStatus2, searchQuery2]);
  ////////////////  Searching For 2 End /////////////////

  const [categorydatar, setCategorydatar] = useState([]);
  const [isLoadingr, setIsLoadingr] = useState(false);
  useEffect(() => {
    fetchDatar();
  }, []);
  const fetchDatar = async () => {
    if (isLoadingr) {
      return;
    }
    setIsLoadingr(true);
    try {
      const response = await fetch(
        `${ip}/api/mstcategories?populate=*&pagination[page]=1&filters[dis][$ne]=Discontinue&sort[0]=id`
      );
      const json = await response.json();
      const allData = [];

      for (let page = 1; page <= json.meta.pagination.pageCount; page++) {
        const pageResponse = await fetch(
          `${ip}/api/mstcategories?populate=*&pagination[page]=${page}&filters[dis][$ne]=Discontinue&sort[0]=id`
        );
        const pageJson = await pageResponse.json();
        const processedData = pageJson.data.map(item => ({
          label: item.attributes.CategoryName,
          value: item.attributes.CategoryCode
        }));
        allData.push(...processedData);
      }
      allData.sort((a, b) => a.label.localeCompare(b.label));
      setCategorydatar(allData);
      setIsLoadingr(false);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };
  const id = localStorage.getItem('id');
  const [user, setUser] = useState<any>([]);
  useEffect(() => {
    fetchDatauser();
  }, []);
  const fetchDatauser = async () => {
    try {
      const response = await fetch(`${ip}/api/user-details/${id}`);
      const json = await response.json();
      const extractedData = json.data.attributes;
      setUser(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  return (
    <>
      <LoadingBar color="#3498ff" progress={progress} onLoaderFinished={() => setProgress(0)} />
      <Container className="main">
        <Stack className="table-toolbar selection-head " justifyContent="space-between">
          <Stack direction="column" alignItems="flex-start">
            <Stack direction="column" alignItems="flex-start">
              <Stack direction="row" alignItems="flex-start" spacing={221}>
                <h3 className="title">Product Masters</h3>
                <div onClick={() => setOpenSet(!openSet)}>
                  <MenuIcon className="burgerMenu1" />
                </div>
              </Stack>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Link to={`/${ugr}/dashboard`}>Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Product Master</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
          </Stack>
        </Stack>
        <Divider
          style={{ marginTop: '-20px' }}
          // className="divide"
        />
        <FlexboxGrid justify="space-between">
          <FlexboxGrid.Item as={Col} colspan={24} md={4}>
            <Panel
              style={{
                width: '100%',
                margin: 'auto',
                boxShadow: '1px 1px 10px -4px',
                height: tableHeight2,
                overflowY: 'auto'
              }}
              bordered
            >
              <Nav
                appearance="subtle"
                reversed
                vertical
                activeKey={activeKey}
                onSelect={handleNavSelect}
              >
                {(user.Category === 'Admin' ||
                  user.MSTCategory === true) && (
                    <Nav.Item eventKey="content1">
                      <b>{label[0]?.attributes.Category}</b>
                    </Nav.Item>
                  )}
                {(user.Category === 'Admin' ||
                  user.MSTPType === true ) && (
                    <Nav.Item eventKey="content2">
                      <b>{label[0]?.attributes.ProductType}</b>
                    </Nav.Item>
                  )}
                {(user.Category === 'Admin' ||
                  user.MSTCollection === true ) && (
                    <Nav.Item eventKey="content3">
                      <b>{label[0]?.attributes.Collection}</b>
                    </Nav.Item>
                  )}
                {(user.Category === 'Admin' ||
                  user.MSTFinish === true )&& (
                    <Nav.Item eventKey="content4">
                      <b>{label[0]?.attributes.finish}</b>
                    </Nav.Item>
                  )}
                {(user.Category === 'Admin' ||
                  user.MSTColor === true )&& (
                    <Nav.Item eventKey="content5">
                      <b>{label[0]?.attributes.color}</b>
                    </Nav.Item>
                  )}
                {(user.Category === 'Admin' || user.MSTHSN === true) && (
                  <Nav.Item eventKey="content6">
                    <b>{label[0]?.attributes.HSN}</b>
                  </Nav.Item>
                )}
                {(user.Category === 'Admin' ||
                  user.MSTMaterial === true ) && (
                    <Nav.Item eventKey="content7">
                      <b>{label[0]?.attributes.MaterialName}</b>
                    </Nav.Item>
                  )}
                {(user.Category === 'Admin' ||
                  user.MSTShape === true ) && (
                    <Nav.Item eventKey="content8">
                      <b>{label[0]?.attributes.Shape}</b>
                    </Nav.Item>
                )}
                {(user.Category === 'Admin' ||
                  user.MSTSeason === true ) && (
                    <Nav.Item eventKey="content9">
                      <b>{label[0]?.attributes.Season}</b>
                    </Nav.Item>
                  )}
                {(user.Category === 'Admin' ||
                  user.MSTPTechnique === true ) && (
                    <Nav.Item eventKey="content10">
                      <b>{label[0]?.attributes.P_Technique}</b>
                    </Nav.Item>
                )}
                {(user.Category === 'Admin' ||
                  user.MSTCosHead === true ) && (
                    <Nav.Item eventKey="content11">
                      <b>Costing Head</b>
                    </Nav.Item>
                  )}
                {(user.Category === 'Admin' ||
                  user.MSTCurrency === true ) && (
                    <Nav.Item eventKey="content12">
                      <b>Currency</b>
                    </Nav.Item>
                  )}
                {(user.Category === 'Admin' ||
                  user.MSTComponent === true ) && (
                    <Nav.Item eventKey="content13">
                      <b>Component</b>
                    </Nav.Item>
                  )}
                {(user.Category === 'Admin' ||
                  user.MSTProcess === true ) && (
                    <Nav.Item eventKey="content14">
                      <b>Process</b>
                    </Nav.Item>
                  )}
              </Nav>
            </Panel>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item as={Col} colspan={24} md={20} style={{ marginBottom: '20px' }}>
            <Panel
              // className="row row1"
              style={{ width: '90%', margin: 'auto', boxShadow: '1px 1px 10px -4px' }}
            >
              {activeKey === 'content1' && (
                <CategoryMaster
                  {...{
                    label,
                    filterDataCata,
                    category,
                    submit,
                    data,
                    isLoading,
                    editedRowIds,
                    editedData,
                    setEditedRowIds,
                    selectedBuyer,
                    searchQuery1,
                    handleEditRowCategory,
                    handleStatusCCat,
                    handleStatusDCat,
                    handleInputChange,
                    handleBuyerChange,
                    handleInputChangeCategory,
                    handleSaveRowCategory,
                    handleSearch1,
                    editedRowId,
                    handleCancelCategory,
                    processInputRef
                  }}
                />
              )}
              {activeKey === 'content2' && (
                <ProductTypeMaster
                  {...{
                    label,
                    productType,
                    categorydatar,
                    discate,
                    fetchDatar,
                    data,
                    submit2,
                    searchQuery2,
                    filterDataOfPrdt,
                    isLoading2,
                    editedRowIdsProduct,
                    editedDataProduct,
                    selectedCategoryCode,
                    setSelectedCategoryCode,
                    selectedBuyerp,
                    setEditedRowIdsProduct,
                    //handle function
                    handleEditRowProduct,
                    handleStatusCptye,
                    handleStatusDptye,
                    handleInputChange2,
                    handleInputChangeProduct,
                    handleSaveRowProduct,
                    handleBuyerChangep,
                    handleSearch2,
                    editedRowIdProduct,
                    handleCancelPtech,
                    processInputRef
                  }}
                />
              )}
              {activeKey === 'content3' && <CollectionMaster />}
              {activeKey === 'content4' && <FinishMaster />}
              {activeKey === 'content5' && <ColorMaster />}
              {activeKey === 'content6' && <HSNCodeMaster />}
              {activeKey === 'content7' && <MaterialNameMaster />}
              {activeKey === 'content8' && <ShapeMaster />}
              {activeKey === 'content9' && <SeasonMaster />}
              {activeKey === 'content10' && <PTechNameMaster />}
              {activeKey === 'content11' && <CostingHeadMaster />}
              {activeKey === 'content12' && <CurrencyMaster />}
              {activeKey === 'content13' && <CompNameMaster />}
              {activeKey === 'content14' && <ProcessMaster />}
            </Panel>
          </FlexboxGrid.Item>
        </FlexboxGrid>
        <Footer />
      </Container>
    </>
  );
};
export default Master;
